var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-unstyled",style:({
    maxWidth: '500px',
    width: '100%',
  })},_vm._l((_vm.items),function(item,i){return _c('li',{key:i,staticClass:"mb-2"},[_c('button',{staticClass:"wet-volksfest-list-item",class:{'active': _vm.value.id === item.id},attrs:{"id":`wet-volksfest-button-${i + 1}`},on:{"click":function($event){$event.preventDefault();_vm.selected = item}}},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"wet-note"},[_vm._v(_vm._s(_vm.subTitle(item)))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }